import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

const Footer= () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // Handle window resize
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [])


  const handleSubmenuClick = (e) => {
    if (windowWidth < 1200) e.preventDefault();
  };

  return (
        <footer class="mil-relative">
          <img src="assets/images//background/background-2.png" class="mil-bg-img mil-parallax" alt="Background iamge" style={{ objectPosition: "top"}} data-value-1="-25s%" data-value-2="23%" styleN/>s
            <div class="container mil-p-120-90">
              <div class="mil-background-grid"></div>
                <div class="row align-items-end">
                  <div class="col-lg-8">
                    <div class="row">
                      <div class="col-12">

                        <div class="mil-footer-navigation mil-up mil-mb-90">
                          <nav>
                            <ul>
                              <li>
                                <NavLink
                                  to="/"
                                  end
                                >
                                  Home
                                </NavLink>
                              </li>
                             <li className={`mil-has-children }`}>
                                <a href="/" onClick={handleSubmenuClick}>
                                  OFERTA
                                </a>
                                <ul>
                                  <li>
                                    <NavLink
                                      to="/budownictwo-mieszkalne"
                                    >
                                      BUDOWNICTWO MIESZKALNE
                                    </NavLink>
                                  </li>
                                  <li>
                                    <NavLink
                                      to="/budownictwo-wielorodzinne"
                                    >
                                      BUDOWNICTWO WIELORODZINNE
                                    </NavLink>
                                    </li>
                                    <li>
                                      <NavLink
                                        to="/budownictwo-uslugowo-przemyslowe"
                                      >
                                        BUDOWNICTWO USŁUGOWO-PRZEMYSŁOWE
                                      </NavLink>
                                    </li>
                                </ul>
                              </li>
                              <li>
                                <NavLink
                                  to="/realizacje"
                                >
                                  REALIZACJE
                                </NavLink>
                              </li>
                              <li>
                                <NavLink
                                  to="/kontakt"
                                >
                                  KONTAKT
                                </NavLink>
                              </li>
                            </ul>
                          </nav>
                        </div>

                        </div>
                          <div class="col-md-6 col-lg-8 col-xl-5">
                            <p class="mil-text-sm mil-up mil-light-soft mil-mb-30">Zapraszamy do kontaktu:<br />Pon - Piąt: 8:00 - 17:00</p>
                            <p className="mil-text-sm mil-up mil-light-soft mil-mb-10">Waryńskiego 33/2, 87-100 Toruń</p>
                            <p className="mil-text-sm mil-up mil-light-soft mil-mb-10">+48 534 727 286</p>
                            <p className="mil-text-sm mil-up mil-light-soft">biuro@holtyn-bud.pl</p>
                        </div>
                                
                      </div>
                    </div>
                    <div class="col-lg-4">
                      <NavLink to="/" className="mil-footer-logo mil-up mil-mb-30">
                        <img
                          src="assets/images/logo/logo-light.png"
                          alt="Logo"
                          style={{ width: "130px"}}
                        />
                      </NavLink>
                    </div>

                  </div>
                </div>
            </footer>
  )
}

export default Footer